"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Avatar = require("../..//Avatar/Avatar.styled");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Skeleton = require("../Skeleton.styled");
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var SkeletonAvatar = function SkeletonAvatar(_ref) {
  var isLoading = _ref.isLoading,
    children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'xlarge' : _ref$size;
  if (isLoading === true || isLoading === undefined) return /*#__PURE__*/_react["default"].createElement(SkeletonAvatarStyled, {
    shape: "circle",
    background: "darkCultured",
    borderColor: "primary",
    size: size
  }, /*#__PURE__*/_react["default"].createElement(SkeletonAvatartInner, null));
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children);
};
var _default = SkeletonAvatar;
exports["default"] = _default;
var SkeletonAvatarStyled = (0, _styledComponents["default"])(_Avatar.AvatarStyled)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tmargin: 1rem 0;\n\toverflow: hidden;\n"])));
var SkeletonAvatartInner = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\twidth: 100%;\n\theight: 100%;\n\t::before {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\tbackground: linear-gradient(\n\t\t\t90deg,\n\t\t\ttransparent,\n\t\t\trgba(255, 255, 255, 0.9),\n\t\t\ttransparent\n\t\t);\n\t\twidth: 50%;\n\t\theight: 100%;\n\t\ttop: 0;\n\t\tleft: 0;\n\t}\n\tanimation: ", " 2s infinite;\n"])), _Skeleton.SkeletonLoadingAnimation);